import type { ReactNode } from "react";

export type GreenProps = ReactNode;

function Green(children: GreenProps) {
  return <span className="__green">{children}</span>;
}

export default Green;
